export default {
  'Extract audio': 'ऑडियो निकालें',
  'Mute': 'म्यूट करें',
  'Split video and audio': 'वीडियो और ऑडियो अलग करें',
}